import { __, pipe, reject, prop, contains, pluck, propEq, findIndex } from 'ramda'
import {
  surveysPaused,
  surveysInField,
} from 'shared/helpers/functional'
import * as types from 'store/sidebar/sidebarTypes'

const initialState = {
  surveys: [],
  activeSurveys: [],
  inactiveSurveys: [],
  surveysToLaunch: [],
  surveysToClose: [],
  timeSlots: [],
  closeWarningOpen: false,
}

const updatedSurveyIds = surveys => pipe(prop('id'), contains(__, pluck('id', surveys)))

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED:
    case types.FINALIZE_PROJECT_SUCCEEDED:
    case types.REOPEN_PROJECT_SUCCEEDED:
      return {
        ...initialState,
    //     surveys: action.payload.surveys,
       }
    case types.FETCH_PROJECT_SURVEYS_SUCCEEDED:
      return {
        ...state,
        activeSurveys: surveysInField(action.payload.surveys),
        inactiveSurveys: surveysPaused(action.payload.surveys),
        surveys: action.payload.surveys,
      }
    case types.INIT_LAUNCH_SURVEYS_REQUESTED:
      return {
        ...state,
        surveysToLaunch: action.payload,
      }
    case types.INIT_CLOSE_SURVEYS_REQUESTED:
      return {
        ...state,
        surveysToClose: action.payload,
        closeWarningOpen: true,
      }
    case types.LAUNCH_SURVEYS_SUCCEEDED:
      return {
        ...state,
        surveysToLaunch: [],
        inactiveSurveys: reject(updatedSurveyIds(action.payload), state.inactiveSurveys),
        activeSurveys: [
          ...state.activeSurveys,
          ...action.payload.map(s => ({
            ...s,
            status: {
              status: s.status.status === 3 ? 2 : 1,
              label: s.status.status === 3 ? 'Re-Fielding' : 'Fielding',
            },
          })),
        ],
      }
    case types.CLOSE_SURVEYS_SUCCEEDED:
      return {
        ...state,
        surveysToClose: [],
        activeSurveys: reject(updatedSurveyIds(action.payload), state.activeSurveys),
        inactiveSurveys: [
          ...state.inactiveSurveys,
          ...action.payload
            .filter(s => findIndex(propEq('id', s.id), state.inactiveSurveys) === -1)
              .map(s => ({
                ...s,
                status: {
                  status: 3,
                  label: 'Closed',
                },
              })),
        ],
      }
    case types.TOGGLE_CLOSE_WARNING_REQUESTED:
      return { ...state, closeWarningOpen: !state.closeWarningOpen }
    case types.EDIT_SAMPLE_SIZE_SUCCEEDED: {
      const updatedSurveys = state.surveys.map(survey => {
        if (survey.id === action.payload.id)
          return {...action.payload}

        return survey
      })

      return {
        ...state,
        surveys: updatedSurveys,
        activeSurveys: surveysInField(updatedSurveys),
        inactiveSurveys: surveysPaused(updatedSurveys),
      }
    }
    default:
      return state
  }
}

export default sidebarReducer
